// Second half of the "doors open" login transition: the destination page is revealed through an
// expanding iris around the owl. Armed by LoginPage via sessionStorage('core-enter').
import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BRAND } from './ui';

export default function EnterReveal() {
  const [show, setShow] = useState(() => {
    try {
      const t = Number(sessionStorage.getItem('core-enter') || 0);
      return t > 0 && Date.now() - t < 6000; // only right after the gate, never on a plain reload
    } catch { return false; }
  });

  useEffect(() => {
    if (!show) return undefined;
    try { sessionStorage.removeItem('core-enter'); } catch { /* ignore */ }
    const t = setTimeout(() => setShow(false), 1500);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div key="reveal" aria-hidden initial={{ opacity: 1 }} exit={{ opacity: 0, transition: { duration: 0.2 } }}
          style={{ position: 'fixed', inset: 0, zIndex: 9999, pointerEvents: 'none' }}>
          {/* navy curtain with a growing hole */}
          <motion.div initial={{ clipPath: 'circle(0% at 50% 46%)' }} animate={{ clipPath: 'circle(150% at 50% 46%)' }} transition={{ duration: 1.05, delay: 0.25, ease: [0.65, 0, 0.35, 1] }}
            style={{ position: 'absolute', inset: 0, background: 'transparent', boxShadow: `0 0 0 400vmax ${BRAND.navy900}`, borderRadius: '50%' }} />
          {/* gold rim following the iris */}
          <motion.div initial={{ scale: 0.1, opacity: 0.9 }} animate={{ scale: 40, opacity: 0 }} transition={{ duration: 1.1, delay: 0.25, ease: [0.65, 0, 0.35, 1] }}
            style={{ position: 'absolute', left: 'calc(50% - 40px)', top: 'calc(46% - 40px)', width: 80, height: 80, borderRadius: '50%', border: '2px solid rgba(226,184,120,0.9)', boxShadow: '0 0 40px rgba(205,155,80,0.55)' }} />
          {/* owl at the center */}
          <motion.img src={BRAND.owl} alt="" initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: [0.6, 1.05, 1, 0.5], opacity: [0, 1, 1, 0] }} transition={{ duration: 1.1, times: [0, 0.3, 0.55, 1], ease: 'easeInOut' }}
            style={{ position: 'absolute', left: 'calc(50% - 60px)', top: 'calc(46% - 60px)', width: 120, filter: 'drop-shadow(0 0 40px rgba(205,155,80,0.8))' }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
